import React from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faChevronRight, faCar} from '@fortawesome/free-solid-svg-icons';
import styles from '../../../styles/rca/RCASearch.module.scss';

const CarTabs = (props) => {

    const {vehiclesNumber, backToAutoList, activeTab} = props;

    const chooseAuto = vehiclesNumber > 1 &&
        <Button variant="link" className="green inline-block" onClick={backToAutoList}>
            <FontAwesomeIcon icon={faCar} className="me-1 " height="16" width="16" />
            Auto
            <Badge className="ms-2" pill variant="primary" >{vehiclesNumber}</Badge>
        </Button>;

    return (
        <Tabs activeKey="auto" className={styles.tab}>
            <Tab eventKey="auto" title={activeTab} disabled >
            </Tab>
            {vehiclesNumber > 0 && 
                <Tab title={chooseAuto} >
                </Tab>
            }
        </Tabs>
    );
}

export default CarTabs;